import apiClient from './api.service';

export interface CertificateOfConformityRecord {
  id: string;
  company_id: string;
  document_number: string;
  document_revision?: string | null;
  date: string;
  job_card_number: string;
  po_number?: string | null;
  job_number?: string | null;
  supplier_po_number?: string | null;
  heat_number?: string | null;
  part_number: string;
  part_description: string;
  part_revision_level?: string | null;
  date_of_completion: string;
  quantity: number;
  qc_engineer: string;
  notes?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
  created_at: string;
  updated_at: string;
}

export interface CertificateOfConformityPayload {
  document_number?: string;
  document_revision?: string | null;
  date: string;
  job_card_number: string;
  po_number?: string | null;
  job_number?: string | null;
  supplier_po_number?: string | null;
  heat_number?: string | null;
  part_number: string;
  part_description: string;
  part_revision_level?: string | null;
  date_of_completion: string;
  quantity: number;
  qc_engineer: string;
  notes?: string | null;
}

export const certificateOfConformityService = {
  getAll: (q?: string) => {
    const params = new URLSearchParams();
    if (q?.trim()) params.set('q', q.trim());
    const query = params.toString();
    return apiClient.get(`/quality/certificates-of-conformity${query ? `?${query}` : ''}`);
  },

  getById: (id: string) => apiClient.get(`/quality/certificates-of-conformity/${id}`),

  create: (payload: CertificateOfConformityPayload) =>
    apiClient.post('/quality/certificates-of-conformity', payload),

  update: (id: string, payload: CertificateOfConformityPayload) =>
    apiClient.put(`/quality/certificates-of-conformity/${id}`, payload),

  delete: (id: string) => apiClient.delete(`/quality/certificates-of-conformity/${id}`),
};
